module.exports = __webpack_public_path__ + "paper-plane-2563.svg";